export default __webpack_public_path__ + "static/media/portfolio.eac3643b.png";